import "../dark.css"
import "./style.css"
import {_t, mdi, logError, GETP, POSTP} from "../function.js";
import "../highlight.js";
import {mdiPound} from "@mdi/js";
import {cat_search} from "../index/search.js";
import "../sphinx/page_scale.js"
import "../sphinx/togle_theme.js"

/**
 * Заголовок по руководству
 * @type {*}
 */
const title_ug = _t('AqNOS. Руководство')
/**
 * Заголоовок справочника
 * @type {*}
 */
const title_cr = _t('AqNOS. Справочник')
/**
 * Заголовок загрузок
 * @type {*}
 */
const title_download = _t('Загрузки')
/**
 * Заголовок загрузок
 * @type {*}
 */
const title_confl = _t('Страницы')
const ai_warning = _t('* Данная запись получена средствами ИИ, любые галлюцинации ИИ должны быть проверены человеком и их использование на ваш страх и риск')

const iconPound = mdi(mdiPound, "#999")

/**
 * Режим темы
 * @type {boolean}
 */
let dark = false


/**
 * Минимальная высота iframe sphinx
 * @type {number}
 */
let minHeight = window.outerHeight / 2 - 70
/**
 * Текущий язык
 * @type {*|jQuery}
 */
const lang = $("html").attr("lang")
/**
 * Расчетная ширина окна поиска
 * @type {number}
 */
let win_with_search = 940

/**
 * Тип поиска мобильный / десктопный
 * @type {string}
 */
let type = 'desc'
let type_app = 'desc'

/**
 * Мобильный режим
 */
let mobile=false
if (document.body.offsetWidth <= 1024) {
    win_with_search = window.outerWidth - 20
    type = 'mob'
    type_app = 'mob'
    minHeight = 70
    mobile=true
}

const aq_loader=`
<div class="a-loading-bar">
    <div class="a-loading-bar__overlay"></div>
        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--visible v-progress-circular--indeterminate teal--text" style="height: 36px; width: 36px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.5 22.5 45 45" style="transform: rotate(0deg);">
                <circle fill="transparent" cx="45" cy="45" r="20" stroke-width="5" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle>
            </svg>
            <div class="v-progress-circular__info">
            </div>
        </div>
    </div>
</div>
`

const text_not_found = `
<div class="not_found_parent">
        <div class="not_found">
            <h3 class="text-lg">${_t('Страницы, содержащие слова запроса, в разделе не найдены.')}</h3>
            <p class="text-xs font-light">${_t('По запросу <b>{{text}}</b> ничего не найдено.')}</p>

            <p class="text-xs font-light">${_t('Рекомендации')}:</p>

            <ul>
                <li class="text-gray">${_t('Убедитесь, что все слова написаны без ошибок.')}</li>
                <li class="text-gray">${_t('Попробуйте использовать другие ключевые слова.')}</li>
                <li class="text-gray">${_t('Попробуйте использовать более популярные ключевые слова.')}</li>
                <li class="text-gray">${_t('Попробуйте уменьшить количество слов в запросе.')}</li>
            </ul>
        </div>
        <div class="{{not_found_img}}"></div>
</div>
`

jqueryts.DataStore.prototype.sorting.as.bylength = function(a,b){
    return a > b ? 1 : -1
}

/**
 * Заголовок сообщений
 * @type {*}
 */
const title_msg = _t('AqNOS. Сообщения')
const title_answer = _t('AqNOS. AI')

let is_admin=false;
if (window.config.auth.code===0)
    if (window.config.auth.id_category===1)
        is_admin=true;

jqueryts.ready(function () {
    class SearchApp{
        xhr_doc = null;
        xhr_file = null;
        xhr_confl = null;
        xhr_msg = null;
        xhr_msg_ai = null;
        xhr_search = null;

        init(){
            const self=this
            jqueryts.ui({
                container: document.getElementById("app-search"),
                id: "app-search",
                css: "v-aq-search-tr",
                type:"clean",
                borderless: true,
                rows: [
                    {
                        css: "v-aq-search-tr title_1",
                        height: 60,
                        template:  `<div class="title_search" style="text-align: left">${_t("Результаты поиска")}</div>`,
                        id: "title_1_app",
                        borderless: true,
                    },
                    {
                        css: "v-aq-search-block",
                        type: "clean",
                        padding:{
                            top:15, bottom:3, left:15, right:15
                        },
                        borderless: true,
                        cols: [
                            {
                                width: 1,
                                borderless: true,
                                template:`<div id='v-aq-search-border'></div>`,
                            },
                            {
                                view: `template`,
                                id: "ai-loader-app",
                                width: 50,
                                borderless: true,
                                template:  (obj)=> {
                                    let icon = `<div class='aq-search-icon'><span class="jqueryts_icon wxi-search"></span></div>`
                                    if (obj.state==='ai-show')
                                        icon=`<div class='ai-loader'><span></span></div>`
                                    return icon
                                },
                                data: {
                                    "state": "search"
                                }
                            },
                            {
                                css: "v-aq-search",
                                id: "search_txt_app",
                                view: "text",
                                placeholder: _t("Поиск по порталу документации"),
                                keyPressTimeout: 100,
                                on: {
                                    onKeyPress: function (code, e) {
                                        try {
                                            if (code === 13) {
                                                self.search($$("search_txt_app").getValue(), 2)
                                                return true
                                            }
                                        } catch (e) {
                                            logError(e)
                                        }
                                    }
                                }
                            },
                            {
                                view: "button",
                                width: 120,
                                height: 45,
                                css: "v-btn-ts-md",
                                value: _t("Найти"),
                                on: {
                                    onItemClick: () => {
                                        try {
                                            self.search($$("search_txt_app").getValue(), 2)
                                        } catch (e) {
                                            logError(e)
                                        }
                                    }
                                }
                            },
                        ]
                    },
                    {
                        view: `template`,
                        id: "ai-informer-app",
                        autoheight: true,
                        type:"clean",
                        borderless: true,
                        template:  (obj)=> {
                            let text =``
                            if (obj.state==="run")
                                text = `<small>Запущен дополнительный поиск с использованием искусственного интеллекта...</small>`
                            if (obj.state==="no-result")
                                text = `<small>Поиск с использованием искусственного интеллекта результатов не дал</small>`
                            if (obj.state==="result")
                                text = `<small>Поиск с использованием искусственного интеллекта дополнил объекты результатов поиска на <b>${obj.count}</b></small>`
                            return `<div class="ia-informer">${text}</div>`
                        },
                        data: {
                            "state": "none",
                            "count": 0
                        }
                    },
                    {
                        type:"clean",
                        borderless: true,
                        hidden:!is_admin,
                        cols: [
                            {},
                            {
                                autoheight:true,
                                type:"clean",
                                borderless: true,
                                width: 150,
                                css: "",
                                template: `<small><a class="link" target="_blank" href="https://aistudio.yandex.ru/platform/folders/${window.config.ai_ya.folder_id}/agents/${window.config.ai_ya.agent_id}">Настройка агента ИИ</a></small>`,
                            },
                        ]
                    },
                    {
                        css: "v-aq-search-tr",
                        height: 70,
                        id: "title_2_app",
                        type:"clean",
                        borderless: true,
                    },
                    {
                        id: "search_block_app",
                        autoheight: true,
                        height: window.outerHeight-600,
                        hidden: true,
                        type:"clean",
                        borderless: true,
                        rows: [
                            {
                                id: "search_part_app",
                                template: (obj) => {
                                    try {
                                        let tag_aq_ug = `<div id="tag_aq_ug_app" onclick="window.search_filter_app('aqnos_ug')"><i class="icon_tag">${iconPound}</i> <span>${title_ug}</span> <b>${obj.count_ug}</b></div>`
                                        let tag_aq_cr = `<div id="tag_aq_cr_app" onclick="window.search_filter_app('aqnos_cr')"><i class="icon_tag">${iconPound}</i> <span>${title_cr}</span> <b>${obj.count_cr}</b></div>`
                                        let tag_files = `<div id="tag_files_app" onclick="window.search_filter_app('files')"><i class="icon_tag">${iconPound}</i> <span>${title_download}</span> <b>${obj.count_file}</b></div>`
                                        let tag_confl = `<div id="tag_confl_app" onclick="window.search_filter_app('confl')"><i class="icon_tag">${iconPound}</i> <span>${title_confl}</span> <b>${obj.count_confl}</b></div>`
                                        let tag_msg   = `<div id="tag_msg_app" onclick="window.search_filter_app('msg')"><i class="icon_tag">${iconPound}</i> <span>${title_msg}</span> <b>${obj.count_msg}</b></div>`
                                        let tag_answer   = `<div id="tag_answer_app" onclick="window.search_filter_app('answer')"><i class="icon_tag">${iconPound}</i> <span>${title_answer}&nbsp;&nbsp;</span> </div>`
                                        if (obj.count_cr == 0) tag_aq_cr = ''
                                        if (obj.count_ug == 0) tag_aq_ug = ''
                                        if (obj.count_file == 0) tag_files = ''
                                        if (obj.count_confl == 0) tag_confl = ''
                                        if (obj.count_msg == 0) tag_msg = ''
                                        if (obj.count_answer_ai == 0) tag_answer = ''

                                        return `
                                        <div class="aq_tag_search">
                                            ${tag_aq_ug} ${tag_aq_cr} ${tag_files} ${tag_confl} ${tag_msg} ${tag_answer}
                                        </div>
                                        `
                                    } catch (e) {
                                        logError(e)
                                    }
                                },
                                data: {
                                    count_ug: 0,
                                    count_cr: 0,
                                    count_file: 0,
                                    count_confl: 0,
                                    count_msg: 0,
                                    count_answer_ai: 0,
                                },
                                autoheight: true
                            },
                            {
                                template: (obj)=>{
                                    if (obj.result==='') return ''
                                    // return `<textarea>${obj.result}</textarea>`
                                    return  `
<div class="search-row-res ai-answer">
<span class="sub-title-search">${title_answer}</span><br>
${obj.result}
<br><span class="msg_agent">${ai_warning}</span><br>&nbsp;
</div>
`
                                },
                                data: {
                                    result: ''
                                },
                                css: "ai-answer-app",
                                id:"ai-answer-app",
                                autoheight: true
                            },
                            {
                                view: "datatable",
                                id: `search_table_app`,
                                css: "aqnos_datatable aqnos_datatable_search",
                                type: "clean",
                                borderless: true,
                                header: false,
                                fixedRowHeight: false,
                                rowLineHeight: 20,
                                rowHeight: 20,
                                scrollX: false,
                                scrollY: false,
                                autoheight: true,
                                columns: [
                                    {
                                        id: "title",
                                        fillspace: true,
                                        template: (obj) => {
                                            try {
                                                let title = ''
                                                if (obj.type === 'sphinx') {
                                                    if (obj.name === 'aqnos_cr') title = title_cr
                                                    if (obj.name === 'aqnos_ug') title = title_ug
                                                }
                                                if (obj.type === 'files')  title=title_download
                                                if (obj.type === 'confl')  title=title_confl
                                                if (obj.type === 'msg')    title=title_msg
                                                const search_txt = $$("search_txt_app").getValue()
                                                let highlight_txt=self.clear_highlight(search_txt)

                                                if (obj.type === 'sphinx') {
                                                    let href=`/${lang}/index/sphinx/${obj.name}_${lang}/${obj.version}/${obj.href}?highlight=${highlight_txt}`
                                                    let desc = []
                                                    obj.desc.map((el, key) => {
                                                        if (key <= 4) {
                                                            desc.push(el)
                                                        }
                                                    })
                                                    let desc_data=``
                                                    if (desc.length>0) {
                                                        desc_data=`<br><a target="_blank"  href="${href}" class="title_search_body">${desc.join('<br>')}</a>`
                                                    }
                                                    let admin_data = ``
                                                    if (window.config.auth.code === 0)
                                                        if (window.config.auth.id_category === 1) {
                                                            admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                        }
                                                    return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a target="_blank" href="${href}" class="title_search_result">${self.light_text(obj.title)}</a>
${desc_data}
${admin_data}
<br>&nbsp;
</span>
`
                                                }
                                                if (obj.type === 'confl') {
                                                    let href=`/${lang}/index/confl/${obj.name}?highlight=${highlight_txt}`
                                                    let desc = []
                                                    obj.desc.map((el, key) => {
                                                        if (key <= 4) {
                                                            desc.push(el)
                                                        }
                                                    })
                                                    let desc_data=``
                                                    if (desc.length>0) {
                                                        desc_data=`<br><a target="_blank"  href="${href}" class="title_search_body">${desc.join('<br>')}</a>`
                                                    }
                                                    let admin_data = ``
                                                    if (window.config.auth.code === 0)
                                                        if (window.config.auth.id_category === 1) {
                                                            admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                        }
                                                    return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a target="_blank" href="${href}"  class="title_search_result">${self.light_text(obj.title)}</a>
${desc_data}
${admin_data}
<br>&nbsp;
</span>
`
                                                }
                                                if (obj.type === "files") {
                                                    let cats = []
                                                    if (obj.id_cat!==null)
                                                        obj.id_cat.map(ct => {
                                                            ct = cat_search.getItem(ct)
                                                            cats.push(`<a href="/${lang}/index/files/${ct.link}?highlight=${search_txt}" class="link">${self.light_text(_t(ct.name))}</a>`)
                                                        })
                                                    let admin_data = ``
                                                    if (window.config.auth.code === 0)
                                                        if (window.config.auth.id_category === 1) {
                                                            admin_data = `<br><small style="font-style: italic">Вес поиска: ${obj.rank}</small>`
                                                        }
                                                    return `
<span class="search-row-res">
<span class="sub-title-search">${title}:</span>
<a href="${obj.file.url}" class="title_search_result"  download="${obj.file.file}" >
    ${self.light_text(_t(obj.file.name))}
</a>

<span class="title_search_body">
    ${self.light_text(_t(obj.file.desc))}<br>
    <b>${_t('В загрузках')}:</b>
        ${cats.join(', ')} 
</span>

${admin_data}
<br>&nbsp;
</span>
                                                `
                                                }

                                                if (obj.type === 'msg') {
                                                    let message_type = ``
                                                    if (obj.message_type) {
                                                        message_type = `<span class="msg_type t_${obj.message_type}">${self.light_text(obj.message_type)}</span>&nbsp;`
                                                    }
                                                    let msg_admin = ``
                                                    let ai_agent = ``
                                                    if (obj.id_agent === 1) {
                                                        ai_agent = `<br><span class="msg_agent">${ai_warning}</span>`
                                                    }

                                                    if (window.config.auth.code === 0)
                                                        if (window.config.auth.id_category === 1) {
                                                            msg_admin = `
<span class="msg_admin">
    Вес поиска: ${obj.rank}<br>
    Данные модуля: <a class="link" href="${obj.module_href}" target="_blank">${obj.module_href}</a><br>
    Функция: ${obj.function_name}<br>
    Макрос: ${obj.macro_name}<br>
    Путь: ${obj.file_path}<br>
    Линия: ${obj.line_no}
</span>
`
                                                        }
                                                    return `
<span class="msg">

    <span class="msg_content">
         ${message_type}
        <code class="message_text">${self.light_text(obj.message_text)}</code>
        <br>
        <span class="msg_content_text">Описание: <span>${self.light_text(obj.description_ru)}</span>&nbsp;</span>
        <br>
        <span class="msg_content_text">Рекомендация: <span>${self.light_text(obj.recommendation_ru)}</span>&nbsp;</span>
        <br>
        <span class="msg_content_text">Модуль: ${self.light_text(obj.module_code)} - &nbsp;<span>${self.light_text(obj.module_desc)}</span></span>
        ${ai_agent}
    </span>
    ${msg_admin}
</span>
`
                                                }

                                            } catch (e) {
                                                logError(e)
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                id: `search_info_app`,
                                template: `#mess#`,
                                data: {
                                    mess: `<div class="frame_null" style="height: 400px"></div>`
                                },
                                height: 400,
                            },

                        ]
                    },

                ],
            })
            jqueryts.extend($$("search_block_app"), jqueryts.OverlayBox);
            const id_search=window.location.pathname.split("/")[4]
            if (id_search)
            GETP(`data/search?id_search=${id_search}`, "message_guide").then(res=>{
                res=res[0]
                $$("search_txt_app").setValue(res.search)
                self.search(res.search, 2)
            })
        }

        clear_highlight(str){
            str = str.replace(/[^a-zA-Z0-9а-яёА-ЯЁ_0-9\s]/g, '')
            const words = str.trim().split(/\s+/)

            const maxLen = 40
            for (let n = Math.min(words.length, 3); n >= 1; n--) {
                const candidate = words.slice(0, n).join(' ')
                if (candidate.length <= maxLen || n === 1) {
                    return candidate.length <= maxLen ? candidate : candidate.substring(0, maxLen)
                }
            }
        }
        search(search_txt, max_length = 3) {
            try {
                const self=this
                $$("search_part_app").show()
                if (search_txt.length < max_length) {
                    // $$("title_1").show()
                    $$("title_2_app").show()
                    $$("search_block_app").hide()
                    return false;
                }
                // $$("title_1").hide()
                $$("title_2_app").hide()
                $$("search_block_app").show()
                if ($("html").hasClass("dark"))
                    dark = true
                else
                    dark = false

                let count = null
                // $$("search_block").hideProgress()
                $$("search_block_app").hideOverlay(aq_loader);
                if (search_txt.trim(' ') !== "") {
                    $$("search_block_app").showOverlay(aq_loader);
                    // $$("search_block").showProgress()
                } else {
                    $$("title_1_app").show()
                    $$("title_2_app").show()
                    $$("search_block_app").hide()
                }

                if (search_txt.trim(' ') !== "") {
                    $$(`search_info_app`).hide()
                    $$(`search_table_app`).hide()
                    $$(`search_table_app`).clearAll()
                    $$(`ai-answer-app`).setValues({"result": ""})

                    $$("search_block_app").showOverlay(aq_loader);


                    if (self.xhr_search) {
                        self.xhr_search.abort();
                        console.log("POST search отменен");
                    }

                    self.xhr_search = new XMLHttpRequest();
                    self.xhr_search.responseType = 'json';
                    self.xhr_search.open('POST', `/${lang}/data/search_add`);
                    self.xhr_search.setRequestHeader('Prefer', 'return=representation');
                    self.xhr_search.setRequestHeader('X-Custom-Ajax', 'true');
                    self.xhr_search.onload = function () {
                        const res = self.xhr_search.response;
                        const id_search = res[0]["id_search"];
                        history.pushState(null, null, `/${lang}/index/search/${id_search}`);

                        Promise.all([
                            self.search_doc(search_txt),
                            self.search_confl(search_txt),
                            self.search_file(search_txt),
                            self.search_msg(id_search),
                        ])
                            .then(responses => {
                                try {
                                    $$(`search_info_app`).hide()
                                    $$(`search_table_app`).show()
                                    $$("search_block_app").hideOverlay();
                                    const sphinx_data=responses[0];
                                    const sphinx_data_cr = sphinx_data.filter(el => el.name === 'aqnos_cr')
                                    const sphinx_data_ug = sphinx_data.filter(el => el.name === 'aqnos_ug')
                                    const confl_data=responses[1];
                                    const file_data=responses[2];
                                    const msg_data=responses[3];

                                    $$(`search_table_app`).parse(confl_data)
                                    $$(`search_table_app`).parse(sphinx_data_ug)
                                    $$(`search_table_app`).parse(sphinx_data_cr)
                                    $$(`search_table_app`).parse(file_data)
                                    $$(`search_table_app`).parse(msg_data)
                                    $$(`search_table_app`).adjustRowHeight(null, null)
                                    $$(`search_table_app`).sort("#rank#","desc","bylength")
                                    $$(`search_part_app`).setValues({
                                        count_cr: sphinx_data_cr.length,
                                        count_ug: sphinx_data_ug.length,
                                        count_file: file_data.length,
                                        count_confl: confl_data.length,
                                        count_msg: msg_data.length,
                                        count_answer_ai: 0
                                    })

                                    const text_not = text_not_found
                                        .replace(`{{text}}`, $$("search_txt_app").getValue())
                                        .replace(`{{not_found_img}}`, "not_found_img_dark")
                                    let count_all = sphinx_data_cr.length
                                        + sphinx_data_ug.length
                                        + file_data.length
                                        + confl_data.length
                                        + msg_data.length
                                    ;
                                    // console.log(count_all)
                                    if (count_all === 0) {
                                        $$(`search_info_app`).show()
                                        $$(`search_table_app`).hide()
                                        $$(`search_info_app`).setValues({mess: text_not})
                                        self.updateHeight(true)
                                    } else {
                                        self.updateHeight()
                                    }

                                } catch (e) {
                                    logError(e)
                                }
                            })
                    }

                    self.xhr_search.onerror = function () {
                        console.error('Ошибка сети search');
                        self.xhr_search = null;
                        reject(new Error('Произошла сетевая ошибка.'));
                    };
                    self.xhr_search.send(JSON.stringify({search: search_txt}));

                }

            } catch (e) {
                logError(e)
            }
        }

        updateHeight(err=false, ai=false, table = false){
            const height_ai     = $$('ai-answer-app').$height
            const height_result = $$('search_table_app').$height
            const height_info   = $$('search_info_app').$height
            const height_part   = $$('search_part_app').$height
            let height          = height_result + height_ai  + height_part +90
            if ($$(`search_table_app`).data.serialize().length===0){
                height = height_ai + height_info + height_part + 90
            }
            if (ai){
                height = height_ai + height_part + 90
            }

            if (table){
                height = height_result + height_part + 90
            }
            if (err){
                height          =  height_ai  + height_part + height_info +90
            }
            $("#app-search").height(height)
            $$("search_block_app").define("height", height)
            $$("search_block_app").resize()
        }


        search_doc(search) {
            const self=this
            return new Promise((resolve, reject) => {
                try {
                    if (self.xhr_doc) {
                        self.xhr_doc.abort(); // Отменяем предыдущий запрос
                        console.log("Предыдущий запрос отменен");
                    }
                    self.xhr_doc = new XMLHttpRequest();
                    self.xhr_doc.responseType = 'json';
                    self.xhr_doc.open('POST', `/${lang}/sphinx/search`);
                    self.xhr_doc.onload = function () {
                        if (self.xhr_doc.status >= 200 && self.xhr_doc.status < 300) {
                            resolve(self.xhr_doc.response.res);
                            self.xhr_doc = null; // Сбрасываем xhr после завершения
                        } else if (self.xhr_doc.status === 400) {
                            console.warn('Поисковый запрос имеет не допустимые символы.', xhr_doc.status);
                            resolve([]);
                            self.xhr_doc = null; // Сбрасываем xhr после завершения
                        } else {
                            console.error('Ошибка запроса:', self.xhr_doc.status);
                            self.xhr_doc = null; // Сбрасываем xhr после завершения
                            reject(new Error(`Ошибка запроса: ${self.xhr_doc.status} ${self.xhr_doc.statusText}`));
                        }
                    };
                    const data = {
                        search: search
                    }
                    const jsonData = JSON.stringify(data)
                    self.xhr_doc.onerror = function () {
                        console.error('Ошибка сети');
                        self.xhr_doc = null; // Сбрасываем xhr после завершения
                        reject(new Error('Произошла сетевая ошибка.'));
                    };
                    self.xhr_doc.send(jsonData);
                } catch (e) {
                    logError(e)
                }
            })
        }

        search_confl(search) {
            const self=this
            return new Promise((resolve, reject) => {
                try {
                    if (self.xhr_confl) {
                        self.xhr_confl.abort(); // Отменяем предыдущий запрос
                        console.log("Предыдущий запрос отменен");
                    }
                    self.xhr_confl = new XMLHttpRequest();
                    self.xhr_confl.responseType = 'json';
                    self.xhr_confl.open('POST', `/${lang}/confl/search`);
                    self.xhr_confl.onload = function () {
                        if (self.xhr_confl.status >= 200 && self.xhr_confl.status < 300) {
                            resolve(self.xhr_confl.response.res);
                            self.xhr_confl = null; // Сбрасываем xhr после завершения
                        } else if (self.xhr_confl.status === 400) {
                            console.warn('Поисковый запрос имеет не допустимые символы.', xhr_confl.status);
                            resolve([]);
                            self.xhr_confl = null; // Сбрасываем xhr после завершения
                        } else {
                            console.error('Ошибка запроса:', self.xhr_confl.status);
                            self.xhr_confl = null; // Сбрасываем xhr после завершения
                            reject(new Error(`Ошибка запроса: ${self.xhr_confl.status} ${self.xhr_confl.statusText}`));
                        }
                    };

                    const data = {
                        search: search
                    }
                    const jsonData = JSON.stringify(data)

                    self.xhr_confl.onerror = function () {
                        console.error('Ошибка сети');
                        self.xhr_confl = null; // Сбрасываем xhr после завершения
                        reject(new Error('Произошла сетевая ошибка.'));
                    };
                    self.xhr_confl.send(jsonData);
                } catch (e) {
                    logError(e)
                }
            })
        }

        /**
         * Функция поиска по файлам
         * @param search_txt
         * @returns {Promise<unknown>}
         */
        search_file(search_txt) {
            const self=this
            return new Promise((resolve, reject) => {
                try {
                    if (self.xhr_file) {
                        self.xhr_file.abort(); // Отменяем предыдущий запрос
                        console.log("Предыдущий запрос отменен");
                    }
                    self.xhr_file = new XMLHttpRequest();
                    self.xhr_file.responseType = 'json';
                    self.xhr_file.open('POST', `/${lang}/files/find_file`);
                    self.xhr_file.onload = function () {
                        if (self.xhr_file.status >= 200 && self.xhr_file.status < 300) {
                            resolve(self.xhr_file.response);
                            const res = self.xhr_file.response
                            if (res === null) {
                                return false;
                            }
                            if (res.length === 0) {
                                return false;
                            }
                        } else if (self.xhr_file.status === 400) {
                            console.warn('Поисковый запрос имеет не допустимые символы.', self.xhr_file.status);
                            resolve([]);
                            self.xhr_file = null; // Сбрасываем xhr после завершения
                        } else {
                            reject(new Error(`Ошибка запроса: ${self.xhr_file.status} ${self.xhr_file.statusText}`));
                        }
                    }
                    const data = {
                        search_text: search_txt, lang: lang
                    }
                    const jsonData = JSON.stringify(data)
                    self.xhr_file.onerror = function () {
                        console.error('Ошибка сети');
                        self.xhr_file = null; // Сбрасываем xhr после завершения
                        reject(new Error('Произошла сетевая ошибка.'));
                    };
                    self.xhr_file.send(jsonData);
                } catch (e) {
                    logError(e)
                }
            })
        }

        /**
         * Функция поиска по сообщениям
         * @param search_txt
         * @returns {Promise<unknown>}
         */
        search_msg(id_search) {
            const self=this
            return new Promise((resolve, reject) => {
                try {
                    if (self.xhr_search) {
                        self.xhr_search.abort();
                        console.log("POST search отменен");
                    }
                    if (self.xhr_msg) {
                        self.xhr_msg.abort();
                        console.log("Предыдущий запрос отменен");
                    }
                    if (self.xhr_msg_ai) {
                        self.xhr_msg_ai.abort();
                        console.log("Предыдущий запрос отменен");
                    }

                    self.xhr_msg = new XMLHttpRequest();
                    self.xhr_msg.responseType = 'json';
                    self.xhr_msg.open('POST', `/${lang}/msg/find_msg`);
                    self.xhr_msg.onload = function () {
                        resolve(self.xhr_msg.response);
                    }

                    const jsonData = JSON.stringify({
                        id_search: id_search
                    })
                    self.xhr_msg.onerror = function () {
                        console.error('Ошибка сети');
                        self.xhr_msg = null;
                        reject(new Error('Произошла сетевая ошибка.'));
                    };
                    self.xhr_msg.send(jsonData);
                    if (window.config.ai_ya.enable){
                        $$("ai-loader-app").setValues({"state": "ai-show"});
                        $$("ai-loader-app").refresh()
                        $$("ai-informer-app").setValues({"state": "run"});
                        $$("ai-informer-app").refresh()
                        self.xhr_msg_ai = new XMLHttpRequest();
                        self.xhr_msg_ai.responseType = 'json';
                        self.xhr_msg_ai.open('POST', `/${lang}/msg/find_msg_ai`);
                        self.xhr_msg_ai.onload = function () {
                            $$("ai-loader-app").setValues({"state": "ai-hide"});
                            $$("ai-loader-app").refresh()
                            const data_ia=self.xhr_msg_ai.response;
                            if (data_ia.matched && self.xhr_msg_ai.response.status===true){
                                data_ia.result.forEach(item => {
                                    item.rank=item.confidence
                                    $$(`search_table_app`).add(item, 0)
                                });
                                $$(`search_table_app`).adjustRowHeight(null, null)
                                const search_part=$$(`search_part_app`).getValues()
                                search_part.count_msg=search_part.count_msg+data_ia.result.length
                                $$(`search_part_app`).setValues(search_part)
                                $$(`search_part_app`).refresh()
                            }
                            if (self.xhr_msg_ai.response.status===true && data_ia.answer!==""){
                                $$(`ai-answer-app`).setValues({"result": data_ia.answer_html})
                                const search_part=$$(`search_part_app`).getValues()
                                search_part.count_answer_ai=1
                                $$(`search_part_app`).setValues(search_part)
                                $$(`search_part_app`).refresh()
                            }



                            if (self.xhr_msg_ai.response.status===false){
                                $$("ai-informer-app").setValues({"state": "no-result"});
                                $$("ai-informer-app").refresh()
                                $$(`ai-answer-app`).setValues({"result": self.xhr_msg_ai.response.text})
                                const search_part=$$(`search_part_app`).getValues()
                                search_part.count_answer_ai=1
                                $$(`search_part_app`).setValues(search_part)
                                $$(`search_part_app`).refresh()
                            }

                            if (!data_ia.matched && data_ia.answer==="")
                            {
                                $$("ai-informer-app").setValues({"state": "no-result"});
                                $$("ai-informer-app").refresh()
                                return false;
                            }

                            let ai_count = data_ia.result.length
                            if (data_ia.answer!=="") ai_count++;
                            $$("ai-informer-app").setValues({state: "result", count:  ai_count});
                            self.updateHeight()

                        }

                        self.xhr_msg_ai.onerror = function () {
                            console.error('Ошибка сети');
                            self.xhr_msg_ai = null;
                            reject(new Error('Произошла сетевая ошибка.'));
                        };
                        self.xhr_msg_ai.send(jsonData);
                    }

                } catch (e) {
                    logError(e)
                }
            })
        }

        /**
         * Функция подсветки текста
         * @param text
         * @returns {*|string}
         */
        light_text(text) {
            try {
                const searchTerm = $$("search_txt_app").getValue()
                if (!searchTerm) {
                    return text;
                }
                if (!text || text === undefined || text === null) {
                    return text;
                }
                const textStr = text.toString();

                // Слова > 2 символов (без учёта коротких)
                const words = searchTerm.split(/\s+/).filter(w => w.length > 2);
                if (!words.length) {
                    return textStr;
                }

                // 1. Подсветка полной фразы
                const escapedPhrase = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const phraseRegex = new RegExp(escapedPhrase, 'gi');
                let result = textStr.replace(phraseRegex, '<span class="mark">$&</span>');

                // 2. Подсветка отдельных слов (не трогаем уже обёрнутые в mark)
                const segments = result.split(/(<span class="mark">.*?<\/span>)/g);
                const escapedWords = words.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
                const wordRegex = new RegExp(`(${escapedWords.join('|')})`, 'gi');

                result = segments.map(seg => {
                    if (seg.startsWith('<span class="mark">')) return seg;
                    return seg.replace(wordRegex, '<span class="mark">$1</span>');
                }).join('');

                return result;
            } catch (e) {
                logError(e)
            }
        }


        /**
         * Запуск поиска (подгрузка директорий и дозагрузка переводов для файлов)
         */
        search_ready() {
            /**
             * Дозагрузка категорий файлов
             */
            POSTP(`data/cat_level`, {level: 3}, "files").then(res => {
                try {
                    res = res.map(el => {
                        return {
                            id: el.id_cat,
                            name: el.name,
                            link: el.link
                        }
                    })
                    cat_search.parse(res)
                } catch (e) {
                    logError(e)
                }
            })
            /**
             * Дозагрузка переводов для файлов
             */
            GETP(`data/translate?id_page=10`, "public").then(res => {
                try {
                    res.map(el => {
                        window.translate.add({
                            id: el.index,
                            index: el.index,
                            [lang]: el[lang]
                        })
                    })
                } catch (e) {
                    logError(e)
                }
            })
        }

    }
    const app=new SearchApp()
    app.init()
    app.search_ready()


    window.search_filter_app = function (type) {
        try {
            if (type==='aqnos_cr' && $('#tag_aq_cr_app').hasClass('active')){
                $('#tag_aq_cr_app').removeClass('active')
                $$('search_table_app').filter();
                app.updateHeight(false, false, true)
                return true
            }
             if(type==='aqnos_ug' && $('#tag_aq_ug_app').hasClass('active')){
                $('#tag_aq_ug_app').removeClass('active')
                $$('search_table_app').filter();
                 app.updateHeight(false, false, true)
                return true
             }
             if(type==='files'    && $('#tag_files_app').hasClass('active')){
                $('#tag_files_app').removeClass('active')
                $$('search_table_app').filter();
                 app.updateHeight(false, false, true)
                return true
             }
             if(type==='confl'    && $('#tag_confl_app').hasClass('active')){
                $('#tag_confl_app').removeClass('active')
                $$('search_table_app').filter();
                 app.updateHeight(false, false, true)
                return true
             }
             if(type==='msg'      && $('#tag_msg_app').hasClass('active')){
                $('#tag_msg_app').removeClass('active')
                $$('search_table_app').filter();
                 app.updateHeight(false, false, true)
                return true
             }
             if(type==='answer'   && $('#tag_answer_app').hasClass('active')){
                $('#tag_answer_app').removeClass('active')
                $$('search_table_app').filter();
                 app.updateHeight(false, false, true)
                return true
             }

            $(".aq_tag_search>div").removeClass("active")
            $$('ai-answer-app').hide();

            switch (type) {
                case 'aqnos_cr':
                    $$('search_table_app').filter(el => el.name === 'aqnos_cr');
                    $('#tag_aq_cr_app').addClass('active')
                    app.updateHeight(false, false, true)
                    break
                case 'aqnos_ug':
                    $$('search_table_app').filter(el => el.name === 'aqnos_ug');
                    $('#tag_aq_ug_app').addClass('active')
                    app.updateHeight(false, false, true)
                    break
                case 'files':
                    $$('search_table_app').filter(el => el.type === 'files');
                    $('#tag_files_app').addClass('active')
                    app.updateHeight(false, false, true)
                    break
                case 'confl':
                    $$('search_table_app').filter(el => el.type === 'confl');
                    $('#tag_confl_app').addClass('active')
                    app.updateHeight(false, false, true)
                    break
                case 'msg':
                    $$('search_table_app').filter(el => el.type === 'msg');
                    $('#tag_msg_app').addClass('active')
                    app.updateHeight(false, false, true)
                    break
                case 'answer':
                    $$('ai-answer-app').show();
                    $$('search_table_app').filter(el => false);
                    $('#tag_answer_app').addClass('active')
                    app.updateHeight(false, true, false)
                    break
            }

        } catch (e) {
            logError(e)
        }
    }
})




